import React from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import MenuIcon from '@material-ui/icons/Menu'
import Close from '@material-ui/icons/Close'
import HomeIcon from '@material-ui/icons/Home'
import SitemapIcon from '@material-ui/icons/Map'
import LogoutIcon from '@material-ui/icons/ExitToApp'
import { AuthContainer } from 'containers'
import { ConfirmAlert, TextLink } from 'components'
import { MenuItem, MenuItemProps } from 'types/menu'

const useStyles = makeStyles({
  menuButton: {
    marginRight: 18,
  },
  menuText: {
    color: '#262626',
    fontSize: 18,
    fontWeight: 300,
  },
})

const MenuListItem: React.FC<MenuItemProps> = (props: MenuItemProps) => {
  const { icon, text, clickHandler } = props.item
  const classes = useStyles()

  return (
    <ListItem button key={text} divider onClick={clickHandler}>
      <div className="mr-2">{icon}</div>
      <ListItemText
        primary={text}
        className="h-9 flex items-center"
        classes={{
          primary: classes.menuText,
        }}
      />
    </ListItem>
  )
}

export default function TemporaryDrawer() {
  const { logOut } = AuthContainer.useContainer()

  const [isOpen, setIsOpen] = React.useState(false)
  const [openLogout, setOpenLogout] = React.useState(false)

  const classes = useStyles()
  const history = useHistory()

  const toggleDrawer = (open: boolean) => (event: any) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setIsOpen(open)
  }

  const menuListItems: MenuItem[] = [
    {
      icon: <SitemapIcon />,
      text: 'Sitemap',
      clickHandler: (e) => {
        history.push('/sitemap')
        toggleDrawer(false)(e)
      },
    },
    {
      icon: <LogoutIcon />,
      text: 'Logout',
      clickHandler: () => {
        setOpenLogout(true)
      },
    },
  ]

  const MenuList = () => {
    return (
      <div data-testid="menu-drawer" className="w-screen sm:w-72 xl:w-96">
        <List>
          <div className="h-18 flex justify-between px-3 items-center">
            <HomeIcon
              className="text-3xl cursor-pointer"
              onClick={(e) => {
                history.push('/home')
                toggleDrawer(false)(e)
              }}
            />
            <Close
              className="text-lg cursor-pointer"
              onClick={(e) => {
                toggleDrawer(false)(e)
              }}
            />
          </div>
          <Divider />
          {menuListItems.map((item) => (
            <MenuListItem key={item.text} item={item} />
          ))}
        </List>
        <section className="flex flex-col absolute bottom-0 bg-black-5 p-4 font-light">
          <p className="underline font-normal mb-3">Useful links</p>
          <p>
            <TextLink hrefLink="https://www.morrisons-corporate.com/suppliers/meet-our-buyers" displayText="GSCOP" />{' '}
            (Contact details and information for Supplier)
          </p>
          <p>
            <TextLink
              hrefLink="https://www.morrisons-corporate.com/investor-centre/financial-reports/"
              displayText="Financial Reports"
            />{' '}
            (Recent Trading Statements of Morrisons)
          </p>
        </section>
      </div>
    )
  }

  return (
    <div>
      <IconButton
        data-testid="menu-button"
        color="inherit"
        aria-label="open drawer"
        edge="start"
        className={classes.menuButton}
        onClick={(e) => {
          toggleDrawer(!isOpen)(e)
        }}
      >
        <MenuIcon />
      </IconButton>
      <Drawer
        anchor="left"
        open={isOpen}
        onClose={(e) => {
          toggleDrawer(false)(e)
        }}
      >
        <MenuList />
      </Drawer>
      {openLogout && (
        <ConfirmAlert
          open={openLogout}
          title="Are you sure you want to log out?"
          onClose={() => setOpenLogout(false)}
          onConfirm={() => {
            setOpenLogout(false)
            logOut()
          }}
        />
      )}
    </div>
  )
}
